import { render, staticRenderFns } from "./HistoryCompany.vue?vue&type=template&id=4bbb93ce"
import script from "./HistoryCompany.vue?vue&type=script&lang=js"
export * from "./HistoryCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports